module.exports = __webpack_public_path__ + "static/media/alpha-homora.166bf75b.svg";